/* eslint-disable */
// eslint-disable-next-line
var defaults = {
  title: "",
  what: "",
  learn: "",
  difference: "",
};

export default {
  data() {
    return {
      item: {
        ...defaults,
      },
      editMode: false,
      showMode: false,
      editIndex: null,
      deleteMode: false,
      newMode: true,
      deleteId: null,
      dialog: false,
      dialogMode: "",
    };
  },
  methods: {
    add() {
      this.item = defaults;
      this.dialogMode = "add";
      // this.editMode = false;
      // this.newMode = true;
      this.dialog = true;
      console.log("Add");
      this.resetItem();
    },
    addItem() {
      let item = {
        index: this.items.length,
        ...this.item,
      };
      this.items.push(item);
      // this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.dialogMode = "";
      // this.newMode = false;
      this.resetItem();
    },
    remove(index) {
      console.log("remove", index);
      // this.deleteMode = true;
      this.dialogMode = "delete";
      this.newMode = false;
      this.deleteId = index;
      this.dialog = true;
    },
    removeItem() {
      const item = this.items.find((x) => x.index === this.deleteId);
      const index = this.items.indexOf(item);
      console.log("removing items", index);
      this.items.splice(index, 1);
      this.cancel();
    },
    edit(index) {
      console.log("edit", index);
      // this.editMode = !this.editMode;
      this.editIndex = index;
      this.item = this.items.find((x) => x.index === index);
      console.log("edit item", this.item);
      this.dialogMode = "edit";
      // this.newMode = false;
      this.dialog = true;
    },
    show(index) {
      console.log("show", index);
      // this.editMode = !this.editMode;
      this.editIndex = index;
      this.item = this.items.find((x) => x.index === index);
      this.dialogMode = "show";
      // this.newMode = false;
      this.dialog = true;
    },
    editItem() {
      this.dialogMode = "";
      this.dialog = false;
      this.resetItem();
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.dialogMode = "";
    },
    populateField(field) {
      return field ? field : "";
    },
    populateArray(field) {
      return field && field.length ? field : [];
    },
    resetItem() {
      this.item = {};
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
